export const CurrencyCodes = [
  "USD",
  "JPY",
  "TND",
  "HKD",
  "BRL",
  "EUR",
  "GBP",
  "CAD",
  "AUD",
  "NZD",
  "PLN",
  "RUB",
  "RON",
  "CZK",
  "CNY",
  "INR",
  "ZAR",
  "INR",
  "KRW",
  "CHF",
  "MYR",
  "SGD",
  "SEK",
  "DKK",
  "NOK",
  "MXP",
  "COP",
  "PEN",
  "CLP",
];
